// generated by @tcg/api-client gen-client — do not edit
import type { paths } from "./schema";
import { createServiceClient, type ServiceClientOptions } from "../../create-client";

export type CmsPaths = paths;
export const CMS_SERVICE = "cms" as const;

/** Typed openapi-fetch client for the cms service (schema `cms`). */
export function createCmsClient(options: ServiceClientOptions) {
  return createServiceClient<paths>("cms", options);
}

export type CmsClient = ReturnType<typeof createCmsClient>;
